import Center from 'shared/components/Center'
import styled from 'styled-components'

import Button from '../../../../shared/components/Button'
import { Feedback } from '../../../../shared/components/Feedback'
import Page from '../../../../shared/components/Page'

export const StyledPage = styled(Page)`
  padding: 65px 0px;
`

export const StyledFeedback = styled(Feedback)`
  padding: 65px 0px;
  width: 100%;
  height: 100%;
`

export const ContainerForm = styled.div`
  display: flex;

  flex: 1;

  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > input {
    width: 40vw;
    max-width: 420px;
    min-width: 513px;
  }
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;
`

export const StyledCenter = styled(Center)`
  position: absolute;
`
